import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";

class OperationScheduleCell extends React.Component {
  static get propTypes() {
    return {
      day: PropTypes.number.isRequired,
      disabled: PropTypes.bool,
      hour: PropTypes.number.isRequired,
      hoverStatus: PropTypes.oneOf(["selecting", "deselecting", false]),
      isSelected: PropTypes.bool,
      onMouseDown: PropTypes.func.isRequired,
      onMouseUp: PropTypes.func.isRequired,
      onHover: PropTypes.func,
      readOnly: PropTypes.bool,
    };
  }

  _handleMouseDown() {
    if (this.props.disabled) {
      return;
    }
    this.props.onMouseDown();
  }

  _handleMouseEnter() {
    if (this.props.disabled) {
      return;
    }
    this.props.onHover();
  }

  _handleMouseUp() {
    if (this.props.disabled) {
      return;
    }
    this.props.onMouseUp();
  }

  render() {
    const { disabled, hour, hoverStatus, isSelected, readOnly } = this.props;
    const classes = classNames("op-sched--hour", {
      "op-sched--hour__selected": isSelected,
      "op-sched--hour__selecting": hoverStatus === "selecting",
      "op-sched--hour__deselecting": hoverStatus === "deselecting",
      "op-sched--hour__disabled": disabled,
      "op-sched--hour__readOnly": readOnly,
    });
    return (
      <Button
        className={classes}
        variant={isSelected ? "primary" : "secondary"}
        onMouseDown={this._handleMouseDown.bind(this)}
        onMouseEnter={this._handleMouseEnter.bind(this)}
        onMouseUp={this._handleMouseUp.bind(this)}
      >
        {`${hour}:00`}
      </Button>
    );
  }
}

export { OperationScheduleCell };
